module.exports = __webpack_public_path__ + "img/air_burgundy.c7f6a649.svg";